module.exports = __webpack_public_path__ + "da7c8fce5690dcc73417de7ba628e3ad.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/AM.svg
// module id = upkC
// module chunks = 0